import * as XLSX from "xlsx";
export const defaultFontStyle = {
    font: { name: "Calibri", sz: 11 },
  };
  
  export const defaultAlignmentStyle = {
    alignment: { vertical: "center", horizontal: "center", wrapText: true },
  };
  
  export const defaultBorderStyle = {
    border: {
      top: { style: "thin", color: { rgb: "000000" } },
      bottom: { style: "thin", color: { rgb: "000000" } },
      left: { style: "thin", color: { rgb: "000000" } },
      right: { style: "thin", color: { rgb: "000000" } },
    },
  };
  
  /**
   * Generates column widths dynamically based on the number of columns.
   * @param {number} columnsCount - Number of columns in the table.
   * @returns {Array} Array of column width objects.
   */
  export const generateColumnWidths = (columnsCount) => {
    const defaultWidth = 150; // Default width for each column
    return Array.from({ length: columnsCount }, () => ({ wpx: defaultWidth }));
  };
  
  /**
   * Applies styles to all cells in the worksheet.
   * @param {Object} worksheet - The worksheet object.
   * @param {number} rows - Total number of rows in the data.
   * @param {number} columnsCount - Number of columns in the table.
   * @param {Object} customStyles - Optional custom styles to override defaults.
   */
  export const applyCellStyles = (worksheet, rows, columnsCount, customStyles = {}) => {
    const baseStyles = {
      ...defaultFontStyle,
      ...defaultAlignmentStyle,
      ...defaultBorderStyle,
      ...customStyles,
    };
  
    for (let rowIndex = 0; rowIndex <= rows; rowIndex++) {
      for (let colIndex = 0; colIndex < columnsCount; colIndex++) {
        const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
        if (worksheet[cellAddress]) {
          worksheet[cellAddress].s = baseStyles;
        }
      }
    }
  };
  